<template>
    <div class="text-white py-1 px-2 font-bold" :class="getColoreStato(stato)">
        {{ getLabelStato(stato) }}
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';

@Options({
    name:'BadgeStato',
    inject: ['getColoreStato', 'getLabelStato'],
    components: {
    },
    props: {
        stato: Object,
    },
})
export default class BadgeStato extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
